import {
    BarChart3,
    Building2,
    Hammer,
    HandCoins,
    KeyRound,
    SlidersHorizontal,
    TrendingUp,
    Wrench,
} from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

const SERVICES = [
    {
        icon: Building2,
        title: "Property Management",
        desc: "Hands-on management of multifamily communities with strong accountability and operational controls.",
    },
    {
        icon: KeyRound,
        title: "Leasing & Occupancy",
        desc: "Strategies designed to improve lead conversion, reduce vacancy, and maximize physical and economic occupancy.",
    },
    {
        icon: HandCoins,
        title: "Collections",
        desc: "Structured collection processes focused on reducing delinquency and improving monthly cash flow.",
    },
    {
        icon: Wrench,
        title: "Maintenance & Make-Ready",
        desc: "Efficient maintenance systems, work-order management, unit turns, and property-condition oversight.",
    },
    {
        icon: Hammer,
        title: "Value-Add Renovations",
        desc: "Execution and supervision of renovation programs designed to improve rents, resident experience, and property value.",
    },
    {
        icon: SlidersHorizontal,
        title: "Expense Management",
        desc: "Vendor management, purchasing controls, budgeting, and operating expense optimization.",
    },
    {
        icon: TrendingUp,
        title: "Asset Stabilization",
        desc: "Focused operational plans for underperforming multifamily properties requiring rapid improvement.",
    },
    {
        icon: BarChart3,
        title: "KPI & Performance Management",
        desc: "Daily and weekly tracking of occupancy, leasing, collections, delinquency, maintenance, and operating performance.",
    },
];

export default function Services() {
    return (
        <section
            id="what-we-do"
            data-testid="services-section"
            className="bg-[#0A1224] py-24 lg:py-32"
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">
                <Reveal className="flex flex-wrap items-end justify-between gap-6">
                    <div>
                        <Eyebrow>What We Do</Eyebrow>
                        <h2 className="mt-6 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
                            Full-stack multifamily operations.
                        </h2>
                    </div>
                    <p className="max-w-sm text-sm leading-relaxed text-slate-400">
                        Eight disciplines, one operating system — built to move occupancy,
                        collections, expenses, and NOI.
                    </p>
                </Reveal>
                <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
                    {SERVICES.map((s, i) => (
                        <Reveal key={s.title} delay={(i % 4) * 0.08} className="h-full">
                            <div
                                data-testid={`service-card-${i + 1}`}
                                className="group h-full rounded-2xl border border-white/10 bg-[#111D36]/60 p-7 transition-all duration-500 hover:-translate-y-1.5 hover:border-[#1BA8E0]/60 hover:bg-[#111D36]"
                            >
                                <div className="flex items-center justify-between">
                                    <s.icon
                                        size={22}
                                        className="text-slate-400 transition-colors duration-500 group-hover:text-[#1BA8E0]"
                                    />
                                    <span className="font-display text-xs font-bold tracking-[0.2em] text-slate-600">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                </div>
                                <h3 className="mt-6 font-display text-lg font-bold tracking-tight text-white">
                                    {s.title}
                                </h3>
                                <p className="mt-3 text-sm leading-relaxed text-slate-400">{s.desc}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
